"use client";

import { useEffect } from "react";
import { usePathname, useSearchParams } from "next/navigation";
import { GOOGLE_ADS_CLICK_COOKIE_NAMES } from "@/lib/google-ads-attribution";

const MAX_AGE_SECONDS = 90 * 24 * 60 * 60;

function setAttributionCookie(name: string, value: string) {
  const secure = window.location.protocol === "https:" ? "; Secure" : "";
  document.cookie = `${name}=${encodeURIComponent(value)}; Max-Age=${MAX_AGE_SECONDS}; Path=/; SameSite=Lax${secure}`;
}

export default function GoogleAdsClickCapture() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    if (!searchParams) {
      return;
    }

    const gclid = searchParams.get("gclid")?.trim();
    const gbraid = searchParams.get("gbraid")?.trim();
    const wbraid = searchParams.get("wbraid")?.trim();

    if (!gclid && !gbraid && !wbraid) {
      return;
    }

    if (gclid) {
      setAttributionCookie(GOOGLE_ADS_CLICK_COOKIE_NAMES.gclid, gclid);
    }
    if (gbraid) {
      setAttributionCookie(GOOGLE_ADS_CLICK_COOKIE_NAMES.gbraid, gbraid);
    }
    if (wbraid) {
      setAttributionCookie(GOOGLE_ADS_CLICK_COOKIE_NAMES.wbraid, wbraid);
    }
    setAttributionCookie(
      GOOGLE_ADS_CLICK_COOKIE_NAMES.clickTs,
      new Date().toISOString()
    );
  }, [pathname, searchParams]);

  return null;
}
